module.exports = __webpack_public_path__ + "static/media/orbitron-regular.19b2f334.ttf";